// Client-side OSINT Intelligence Service for React
// Communicates with the backend server which handles the OSINT analysis agents

// Helper to determine the API base URL depending on environment
const getApiUrl = (path) => {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `http://localhost:3001${path}`;
  } else if (hostname === 'newreports.apexionx.com') {
    return `https://reportsnew.apexionx.com${path}`;
  }
  return path; // relative path in other environments
};

export class OSINTIntelligenceService {
  async processOSINTResults(osintType, osintData, options = {}) {
    return this.processExecutedOSINTResults(osintType, osintData, options);
  }

  // Get appropriate analysis type based on OSINT data type
  getRecommendedAnalysisType(osintType) {
    const typeMapping = {
      'username': 'person',
      'people': 'person',
      'social': 'social',
      'background': 'person',
      'url': 'threat',
      'domain': 'threat',
      'ip': 'threat',
      'email': 'person',
      'phone': 'person'
    };

    return typeMapping[osintType] || 'general';
  }

  // Enhanced analysis for executed OSINT tools - routes requests through backend
  async processExecutedOSINTResults(osintType, osintData, options = {}) {
    try {
      console.log(`[Client OSINT Service] Processing ${osintType} results via backend...`);
      const apiUrl = getApiUrl('/api/ai/osint-analyze');
      
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          osintType,
          osintData,
          options
        })
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server error: ${response.status} - ${errorText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('[Client OSINT Service] Error during OSINT analysis:', error);
      return {
        success: false,
        error: error.message,
        processingTime: new Date().toISOString()
      };
    }
  }
}

// Stubs for backward compatibility exports
export class OSINTAnalyzerAgent {}
export class ThreatAssessmentAgent {}
export class PeopleIntelligenceAgent {}
export class SocialMediaIntelligenceAgent {}
 